import { render } from "./BaseSidebar.vue?vue&type=template&id=7aa162fe"
import script from "./BaseSidebar.vue?vue&type=script&lang=js"
export * from "./BaseSidebar.vue?vue&type=script&lang=js"

import "./BaseSidebar.vue?vue&type=style&index=0&id=7aa162fe&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__